import { HypeItErrorModuleType as ApiHypeItErrorModuleType } from 'src/api/generated/touring/types';
import { HypeItErrorModuleType } from '../../types';
import { mapHypeItErrorRangeType } from '../mapHypeItErrorRangeType';

export const mapHypeItErrorModuleType = (
  apiType: ApiHypeItErrorModuleType
): HypeItErrorModuleType => ({
  name: apiType.name,
  platform: apiType.platform,
  description: apiType.description,
  short: apiType.short,
  ranges: apiType.ranges.map(mapHypeItErrorRangeType),
});
